<template>
  <el-dialog
    @close="onClose"
    :visible="visible"
    title="导出文件"
    destroy-on-close
    :close-on-click-modal="false"
    width="50%"
  >
    <el-scrollbar
      :native="false"
      :noresize="false"
      tag="div"
      style="height: 40vh"
      wrap-class="modal-scrollbar"
    >
      <div class="dialog-body" v-html="exportMessage"></div>
    </el-scrollbar>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="onClose">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ReconnectingWebSocket from 'reconnecting-websocket'
import request, { websocketUrl } from '../../utils/request'
import { getUuid } from '@/utils'

export default {
  name: 'ExportModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      websocket: null,
      exportMessage: null,
      tempMsg: '',
      timeout: 3 * 1000, // 3秒一次心跳
      timeoutObj: null, // 心跳心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null, // 断开 重连倒计时
    }
  },
  created() {
    this.createWebsocket()
    this.openDownload();
  },
  watch: {},
  methods: {
    // 关闭弹框
    onClose() {
      this.$emit('onClose')
    },
    // 创建 websocket 链接
    createWebsocket() {
      if (typeof WebSocket === 'undefined') {
        this.$message.error('您的浏览器不支持socket')
      } else {
        console.log('浏览器支持socket')
      }

      // this.sid = sid;
      const token = localStorage.getItem('TokenKey')
      this.websocket = new ReconnectingWebSocket(
        `${websocketUrl}/excel/websocket/user?sid=${this.params.sid}&&token=${token}`
      )

      // 连接发生错误的回调方法
      this.websocket.onerror = this.websocketOnerror
      // 连接成功建立的回调方法
      this.websocket.onopen = this.websocketOnopen
      // 接收到消息的回调方法
      this.websocket.onmessage = (event) => {
        this.websocketOnmessage(event, this.params.sid)
      }
      // 连接关闭的回调方法
      this.websocket.onclose = this.websocketOnclose
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      this.websocket.onbeforeunload = this.websocketOnbeforeunload
    },
    // 连接发生错误的回调方法
    websocketOnerror() {
      console.log('连接发生错误的回调方法')
    },
    // 连接成功建立的回调方法
    websocketOnopen() {
      if (this._isDestroyed) {
        // this.sid = null
        return false
      }
      this.start()
      console.log('连接成功建立的回调方法')
    },
    // 接收到消息的回调方法
    websocketOnmessage(event) {
      console.log(event)
      const data = JSON.parse(event.data)
      // console.log('接收到消息的回调方法', data);
      this.exportMessage = `${this.tempMsg}<span style="font-weight: 600">${data.message}</span><br/>`
      this.tempMsg += `${data.message}<br/>`
      // 滑动条移动到最底部
      this.$nextTick(() => {
        const div = document.getElementsByClassName('modal-scrollbar')[0]
        div.scrollTop = div.scrollHeight
      })
    },
    // 连接关闭的回调方法
    websocketOnclose() {
      console.log('连接关闭的回调方法')
    },
    // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
    websocketOnbeforeunload() {
      this.closeWebSocket()
      console.log(
        '监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常'
      )
    },
    websocketsend(messsage) {
      console.log('推送了消息', messsage);
      this.websocket.send(messsage);
    },
    start() {
      // 开启心跳
      if (this.timeoutObj) clearTimeout(this.timeoutObj)
      if (this.serverTimeoutObj) clearTimeout(this.serverTimeoutObj)
      this.timeoutObj = setTimeout(() => {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息，
        console.log(this.websocket)
        if (this.websocket && this.websocket.readyState === 1) {
          // 如果连接正常
          console.log('连接正常')
          this.websocketsend('heartbeat')
        } else {
          console.log('连接失败，重新链接')
          // 否则重连
          this.reconnect()
        }
        this.serverTimeoutObj = setTimeout(() => {
          console.log('超时重连')
          // 超时关闭
          // this.websocket.close();
          this.reconnect()
        }, this.timeout)
      }, this.timeout)
    },
    reconnect() {
      // 重新连接
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      if (this.timeoutnum) clearTimeout(this.timeoutnum);
      this.timeoutnum = setTimeout(() => {
        // 新连接
        this.createWebsocket();
        this.lockReconnect = false;
      }, 5000);
    },
    // 关闭WebSocket连接
    closeWebSocket() {
      console.log('关闭');
      this.websocket.close();
      this.sid = undefined;
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
    },
    openDownload() {
      request.post('/excel/excelController/repeatedWriteExport', this.params).then(() => {
        // if (res.success) {
        // }
      });
    },
    // /** @desc 按钮关闭事件 */
    // dialog_btnClose() {
    //   this.propsObj.visible = false;
    //   this.$parent.modalName = null;
    //   this.closeWebSocket();
    //   this.$forceUpdate();
    // },
    // // 下载模板
    // download_modal() {
    //   const a = document.createElement('a');
    //   a.href = `/excel/excelImportController/demoFile?configCode=${
    //     this.propsObj.configCode
    //   }&token=${Storage.l.get('TokenKey')}`;
    //   document.body.appendChild(a);
    //   a.click(); // 下载
    //   URL.revokeObjectURL(a.href); // 释放URL 对象
    //   document.body.removeChild(a); // 删除 a 标签
    // },
    // // 开始上传
    // startUpload(type) {
    //   const formData = new FormData();
    //   this.files.map((v) => {
    //     const item = v;
    //     formData.append('file', item);
    //     return item;
    //   });
    //   const urlParam = `?configCode=${this.propsObj.configCode}&webSocketClientId=${this.sid}&test=${type}`;
    //   this.uploadLoading = true;
    //   request
    //     .postform(`/excel/excelImportController/import${urlParam}`, formData)
    //     .then((res) => {
    //       this.uploadLoading = false;
    //       if (res.success) {
    //         // this.$message.success('上传成功');
    //         // this.$parent.modalName = null;
    //         // this.closeWebSocket();
    //         // this.propsObj.visible = false;
    //         // this.$parent.getList();
    //       }
    //     })
    //     .catch(() => {
    //       this.uploadLoading = false;
    //     });
    // },
    // // 下载原文件或失败文件
    // download_originfile(type) {
    //   const objectName = type === 'success' ? this.propsObj.row.objectName : this.propsObj.row.objectNameAsImportFail;
    //   const a = document.createElement('a');
    //   a.href = `/upload/downloadController/downloadExcelFile?objectName=${objectName}`;
    //   document.body.appendChild(a);
    //   a.click(); // 下载
    //   URL.revokeObjectURL(a.href); // 释放URL 对象
    //   document.body.removeChild(a); // 删除 a 标签
    // },
    // beforeUpload(files) {
    //   const { name, size } = files;
    //   let fileType = name.split('.')[name.split('.').length - 1];
    //   fileType = fileType.toLowerCase();
    //   const isLt40M = size / 1024 / 1024 <= 40;
    //   if (this.accept && this.accept.indexOf(fileType) === -1) {
    //     this.isUpload = true;
    //     this.$message.warning(`当前限制选择 ${this.accept} 类型件，本次选择了错误文件`);
    //     return false;
    //   }
    //   if (!isLt40M) {
    //     this.loading = false;
    //     this.$message.error('上传表格大小不超过40MB');
    //     this.$refs.upload.clearFiles();
    //     return false;
    //   }
    //   return true;
    // },
    // handleChange(file, fileList) {
    //   this.files = [];
    //   fileList.map((v) => {
    //     const item = v;
    //     this.files.push(item.raw);
    //     return item;
    //   });
    // },
    // handleRemove(file) {
    //   this.tableList.forEach((v, k) => {
    //     if (v.url === file.url) {
    //       this.tableList.splice(k, 1);
    //     }
    //   });
    //   this.tableList = this.tableList.concat([]);
    //   this.value.fileList = this.tableList;
    //   this.$emit('onGetFileList', this.tableList);
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleSuccess(res) {
    //   this.isUpload = false;
    //   if (res.code === 200 && res.success) {
    //     res.result.forEach((v) => {
    //       this.tableList.push({
    //         fileName: v.fileName,
    //         url: v.url,
    //         urlPath: v.urlPath,
    //         urlPathPrefix: v.urlPathPrefix,
    //         objectName: v.objectName,
    //       });
    //       this.tableList = this.tableList.concat([]);
    //       this.value.fileList = this.tableList;
    //       this.$emit('onGetFileList', this.tableList);
    //     });
    //   }
    // },
    // handleExceed(files, fileList) {
    //   console.log(files, fileList);
    // },
    // beforeRemove(file) {
    //   if (!this.isUpload) {
    //     return this.$confirm(`确定移除 ${file.name}？`);
    //   }
    //   this.isUpload = false;
    //   return true;
    // },

    // reset() {
    //   // 重置心跳
    //   // 清除时间
    //   clearTimeout(this.timeoutObj);
    //   clearTimeout(this.serverTimeoutObj);
    //   // 重启心跳
    //   this.start();
    // },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
.dialog-body {
  padding: 20px;
}
// .dialog-footer {
//   position: absolute;
//   bottom: 0;
//   right: 20px;
//   display: flex;
//   justify-content: flex-end;
//   width: 100%;
//   z-index: 99;
//   background-color: white;
// }
// /deep/ .el-upload-dragger,
// /deep/ .el-upload {
//   width: 98%;
// }
// .flex {
//   display: flex;
//   align-items: flex-end;
//   .upload-demo {
//     flex: 1;
//     margin-right: 20px;
//   }
// }
</style>
